import {
  Clothes,
  DCCloseUp,
  Sample,
  SampleHero,
  Textiles,
} from "../../../assets/images";
import Button from "../../../components/element/button";
import Col from "../../../components/element/col";
import Container from "../../../components/element/container";
import Icon from "../../../components/element/icon";
import Image from "../../../components/element/image";
import Row from "../../../components/element/row";

export default function AboutIntro() {
  const elementList = [
    { label: "Quality & Sustainability", image: Textiles },
    // { label: "Natural Materials", image: Textiles },
    // { label: "Exceptional Results", image: Clothes },
  ];

  return (
    <Container className="about-intro">
      <Row className="_row intro-content">
        <Image src={DCCloseUp} className="_img intro" />
        <Col className="v-flex gap-5">
          {/* <p className="_label intro-tag">
            About <span>DC Fashion</span>
          </p> */}
          <h2 className="_label intro-title">ABOUT DC FASHION</h2>
          <p className="_label intro-subtitle">
            DC Fashion Store is 100% owned by car enthusiasts.
            <br />
            <br />
            Since 2019 DC Fashion has been committed to bringing you the highest
            quality threads with all our products being designed from scratch at
            our design studios based in Malaysia, Klang.
            <br />
            <br />
            Every piece is expertly designed, tested, and crafted from premium,
            sustainable fabrics. Our caps, shoes, and accessories feature
            exclusive moulds for a perfect fit.
            <br />
            <br />
            Email us: info@dhub.my
            <br />
            {/* Call us: +6012-6566969 */}
          </p>
          <Row className="_row element-list">
            {elementList.map((element, elementIndex) => (
              <Row key={elementIndex} className="h-flex gap-4">
                {/* <Image src={element.image} className="_img material" /> */}
                <h5 className="_label intro-element">{element.label}</h5>
              </Row>
            ))}
          </Row>
          <Col className="_row quote-frame">
            <p className="_label intro-quote">
              {/* “ Neque porro quisquam est qui dolorem ipsum quia dolor sit amet,
              consectetur, adipisci velit Neque porro quisquam est qui dolorem
              ipsum quia dolor sit amet, consectetur, adipisci velit ... ” */}
              All DC Fashion garments are proudly designed and manufactured in
              Malaysia, ensuring precision, quality, and attention to detail at
              every stage.
              <br />
              <br />
              Each piece undergoes an extensive design and testing process
              before release, using only the highest quality fabrics, carefully
              selected from renewable and sustainable sources whenever possible.
              <br />
              <br />
              Our caps and accessories are crafted by top-tier luxury
              manufacturers, developed with our exclusive moulds, patents, and
              shaping to achieve the perfect fit and comfort.
              <br />
              <br />
              Meanwhile, all stickers and banners are handcrafted to order in
              Local Malaysia, maintaining our signature quality and
              authenticity.
            </p>
          </Col>
          <Row>
            <Button
              className="_button contact-now"
              onClick={() => {
                const contactUs = document.getElementById("contact-us");
                if (contactUs) {
                  const yOffset = -150;
                  const y =
                    contactUs.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;

                  window.scrollTo({ top: y, behavior: "smooth" });
                }
              }}
            >
              <Icon icon="lsicon:arrow-right-filled" />
              <p>Contact Us</p>
            </Button>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
